import { safeGet, safeKeys, safeRemove, safeSet } from "./safeStorage";
import { certificateTypesFrom } from "./certificateSelection";

export const CART_STORAGE_KEY = "aramfix-cart";
export const CART_TOKEN_KEY = "aramfix-cart-token";
export const CART_RECOVERY_PREFIX = "aramfix-cart-recovery-";
export const CART_RECOVERY_MAX_AGE_MS = 15 * 60 * 1000;

export const normalizeStoredCart = (stored) => {
  const source = Array.isArray(stored) ? stored : (Array.isArray(stored?.items) ? stored.items : []);
  return source.filter(item => item && typeof item === "object").map(item => {
    const quantity = Number(item.quantity ?? item.confirmed_quantity ?? item.total_units);
    const cartCreatedAt = item.cartCreatedAt || item.commerceSnapshot?.checked_at || null;
    const certificateTypes = certificateTypesFrom(item);
    return Number.isFinite(quantity) && quantity > 0 ? { ...item, quantity, certificateTypes, certificateType: certificateTypes[0] || "NONE", ...(cartCreatedAt ? { cartCreatedAt } : {}) } : null;
  }).filter(Boolean);
};

const recoveryTimestamp = key => Number(String(key || "").slice(CART_RECOVERY_PREFIX.length));

const recoveryKeys = () => safeKeys().filter(key => key.startsWith(CART_RECOVERY_PREFIX));

export const discardCartRecoveries = () => {
  recoveryKeys().forEach(key => safeRemove(key));
};

const pruneExpiredCartRecoveries = (now = Date.now()) => {
  recoveryKeys().forEach(key => {
    const timestamp = recoveryTimestamp(key);
    if (!Number.isFinite(timestamp) || now - timestamp > CART_RECOVERY_MAX_AGE_MS) safeRemove(key);
  });
};

export const persistStoredCart = cart => safeSet(CART_STORAGE_KEY, JSON.stringify(normalizeStoredCart(cart)));

export const readStoredCart = (now = Date.now()) => {
  pruneExpiredCartRecoveries(now);
  const primary = safeGet(CART_STORAGE_KEY, null);
  if (primary !== null) {
    try {
      return normalizeStoredCart(JSON.parse(primary));
    } catch {
      safeRemove(CART_STORAGE_KEY);
    }
  }

  const candidates = safeKeys()
    .filter(key => key.startsWith(CART_RECOVERY_PREFIX))
    .map(key => ({ key, timestamp: recoveryTimestamp(key) }))
    .filter(row => Number.isFinite(row.timestamp) && now - row.timestamp <= CART_RECOVERY_MAX_AGE_MS)
    .sort((left, right) => right.timestamp - left.timestamp);
  const recovery = candidates[0];
  if (!recovery) return [];
  let restored = [];
  try {
    restored = normalizeStoredCart(JSON.parse(safeGet(recovery.key, "[]")));
  } catch {
    restored = [];
  }
  safeRemove(recovery.key);
  if (restored.length) persistStoredCart(restored);
  return restored;
};